function shareTheArticle() {
  [...document.querySelectorAll('.share-the-article')]?.forEach(event => {

    function getCurrentURL () {
      return window.location.href
    }

    const currentPageUrl = getCurrentURL();

    const copyLink = document.querySelector('.share-the-article .s-link');
    const unsecuredCopyToClipboard = (text) => { const textArea = document.createElement("textarea"); textArea.value=text; document.body.appendChild(textArea); textArea.focus();textArea.select(); try{document.execCommand('copy')}catch(err){console.error('Unable to copy to clipboard',err)}document.body.removeChild(textArea)};


    copyLink?.addEventListener('click', (event) => {
      const currentPageUrl = getCurrentURL();
      event.preventDefault()
      /**
       * Copies the text passed as param to the system clipboard
       * Check if using HTTPS and navigator.clipboard is available
       * Then uses standard clipboard API, otherwise uses fallback
      */
      if (window.isSecureContext && navigator.clipboard) {
        navigator.clipboard.writeText(currentPageUrl);
      } else {
        unsecuredCopyToClipboard(currentPageUrl);
      }
    });
  })
}

document.addEventListener( 'DOMContentLoaded', function() {
  shareTheArticle();
})
